import jewelryAccessories from "@/assets/categories/jewelry-accessories.jpg";
import clothingShoes from "@/assets/categories/clothing-shoes.jpg";
import homeLiving from "@/assets/categories/home-living.jpg";
import weddingParty from "@/assets/categories/wedding-party.jpg";
import toysEntertainment from "@/assets/categories/toys-entertainment.jpg";
import artCollectibles from "@/assets/categories/art-collectibles.jpg";
import beautyPersonalCare from "@/assets/categories/beauty-personal-care.jpg";
import kidsBaby from "@/assets/categories/kids-baby.jpg";

export const categoryImages: Record<string, string> = {
  "b902fc8a-10fa-47af-a505-86f893db9131": jewelryAccessories, // Jewelry & Accessories
  "8d95e9c6-6d9c-42c5-9e4c-079e68c66d90": clothingShoes, // Clothing & Shoes
  "161d1c16-8b6f-4369-8c17-9cf65a115c0d": homeLiving, // Home & Living
  "d32ba65f-c552-4d85-afe8-5894b04cab31": weddingParty, // Wedding & Party
  "3c1f6dbd-e2e1-41e7-b5a7-0ab6aafdca81": toysEntertainment, // Toys & Entertainment
  "02429968-e8d0-4e7e-b47c-ee85e14449eb": artCollectibles, // Art & Collectibles
  "e5d87c34-c893-47db-af7a-25da48a059dc": beautyPersonalCare, // Beauty & Personal Care
  "93d387d1-d36b-4fa8-a897-e61fc8070033": kidsBaby, // Kids & Baby
};
